import {CommonMessages} from '../common.messages';

export const PanelClientsAddIndividualMessages = {
    GetIndividualFailed: {
        key: 'GetIndividualFailed',
        message: 'Error while communication with the server. Unable to get individual details'
    },
    GetCountriesFailed: {
        key: 'GetCountriesFailed',
        message: 'Error while communication with the server. Unable to get countries'
    },
    GetCountriesInvalidData: {
        key: 'GetCountriesInvalidData',
        message: 'Error while communication with the server. Invalid countries information.'
    },
    ...CommonMessages
};
